export default {
  button: {
    submit: 'ok',
  },
  tips: {
    noName: 'Please input the name',
  },
  delete: 'Confirm to delete this',
  creat: 'Confirm to cancel the creation of this favorites?',
};
